import { gql } from 'urql';

export const getTokenId = gql`
  query GetTokenId {
    tokenId
  }
`;
